var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMastercardIcon = function SvgMastercardIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_10473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.47149C0 2.3923 1.68552 0.706787 3.76471 0.706787H28.2353C30.3145 0.706787 32 2.3923 32 4.47149V19.5303C32 21.6095 30.3145 23.295 28.2353 23.295H3.76471C1.68552 23.295 0 21.6095 0 19.5303V4.47149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1684 16.7921C15.054 17.7315 13.6084 18.2985 12.0288 18.2985C8.50421 18.2985 5.64697 15.4753 5.64697 11.9926C5.64697 8.51001 8.50421 5.68677 12.0288 5.68677C13.6084 5.68677 15.054 6.25384 16.1684 7.19319C17.2828 6.25384 18.7284 5.68677 20.308 5.68677C23.8326 5.68677 26.6898 8.51001 26.6898 11.9926C26.6898 15.4753 23.8326 18.2985 20.308 18.2985C18.7284 18.2985 17.2828 17.7315 16.1684 16.7921Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1685 16.7922C17.5407 15.6356 18.4108 13.9145 18.4108 11.9926C18.4108 10.0708 17.5407 8.34972 16.1685 7.1931C17.2828 6.2538 18.7284 5.68677 20.308 5.68677C23.8325 5.68677 26.6898 8.51001 26.6898 11.9926C26.6898 15.4753 23.8325 18.2985 20.308 18.2985C18.7284 18.2985 17.2828 17.7315 16.1685 16.7922Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1685 16.7934C17.5406 15.6368 18.4107 13.9158 18.4107 11.994C18.4107 10.0722 17.5406 8.35119 16.1685 7.19458C14.7963 8.35119 13.9263 10.0722 13.9263 11.994C13.9263 13.9158 14.7963 15.6368 16.1685 16.7934Z",
    fill: "#FF5E00"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.20679,
    width: 31,
    height: 21.5882,
    rx: 3.5,
    stroke: "#E1E1E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_10473"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.706787,
    width: 32,
    height: 22.5882,
    rx: 4,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMastercardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mastercard-icon.7e71fea6e23be9680c6f780bda6ac3b2.svg";